




















































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import AnswerRadioGroup from '@/views/material/TestQuestionAnswerRadioGroup.vue';
import {EmptyTestAnswer, getCorrectAnswer, Question, TestAnswer} from '@/types/content/Question';

@Component({
  components: {
    AnswerRadioGroup,
  },
})
export default class TestQuestion extends Vue {
  // prop
  @Prop()
  index!: number;
  @Prop()
  question!: Question;

  // data
  selectedAnswer: TestAnswer = EmptyTestAnswer;
  answered: boolean = false;

  // computed
  get isSelected(): boolean {
    return this.selectedAnswer.label !== '';
  }

  get isAnswered(): boolean {
    return this.answered;
  }

  get hasThumbnail(): boolean {
    if (!this.question) {
      return false;
    }
    return !!this.question.imageFilePath;
  }

  get imagePath(): string {
    if (this.isAnswered && this.question.exampleImageFilePath) {
      return this.question.exampleImageFilePath;
    }
    if (this.question.imageFilePath) {
      return this.question.imageFilePath;
    }
    return '';
  }

  get resultLabel(): string {
    const correct = this.correct(this.question.answers);
    if (correct.label === this.selectedAnswer.label) {
      return '正解！！';
    }
    return '不正解！';
  }

  get correctLabel(): string {
    const correct = this.correct(this.question.answers);
    return correct.label;
  }

  get answerLabel(): string {
    return this.selectedAnswer.label;
  }

  // watch
  @Watch('index')
  onChangeQuestion() {
    this.selectedAnswer = EmptyTestAnswer;
    this.answered = false;
  }

  // method
  correct(answers: TestAnswer[]): TestAnswer {
    return getCorrectAnswer(answers);
  }

  select(answer: TestAnswer): void {
    this.selectedAnswer = answer;
  }

  answer(): void {
    this.answered = true;
  }

  @Emit('done')
  done(): TestAnswer {
    return this.selectedAnswer;
  }
}
